"use client";

import React from "react";
import { ArrowRight, PhoneCall, CircleCheck as CheckCircle2 } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const features = [{
  id: 1,
  text: "Apoio técnico especializado e testes de aplicação"
}, {
  id: 2,
  text: "Representante exclusivo Spraying Systems Co."
}, {
  id: 3,
  text: "Soluções à medida com eficiência comprovada"
}];
export default function CallToAction() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="calltoaction" data-nav="light" className="relative py-16 md:py-24 bg-background overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 20
      }} whileInView={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="relative rounded-3xl bg-primary text-primary-foreground px-6 py-12 md:p-16 lg:p-20 shadow-xl overflow-hidden">
          {/* Subtle background decorative shapes */}
          <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-secondary/20 blur-3xl" />
          <div aria-hidden="true" className="pointer-events-none absolute -left-20 -bottom-20 h-80 w-80 rounded-full bg-secondary/15 blur-2xl" />

          <div className="relative z-10 max-w-3xl mx-auto text-center space-y-6">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-default font-bold tracking-tight text-primary-foreground">
              Otimize os seus processos de pulverização industrial
            </h2>

            <p className="text-base sm:text-lg text-primary-foreground/80 max-w-2xl mx-auto font-normal">
              Fale com os nossos especialistas técnicos para dimensionar a solução exata para a sua indústria e reduzir custos operacionais.
            </p>

            {/* Value checklist */}
            <div className="pt-2 pb-4 flex flex-wrap justify-center gap-y-3 gap-x-6 text-sm text-primary-foreground/90">
              {features.map((feature, i) => <div key={feature.id} data-index={i} className="flex items-center gap-2">
                  <CheckCircle2 className="size-4 text-secondary shrink-0" />
                  <span>{feature.text}</span>
                </div>)}
            </div>

            {/* Action buttons */}
            <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto bg-secondary text-secondary-foreground hover:bg-secondary/90 text-base font-semibold px-8 py-6 rounded-xl shadow-md transition-[background-color,box-shadow]">
                <Link to="/ContactsPage" className="inline-flex items-center gap-2">
                  <span>Solicite um orçamento</span>
                  <ArrowRight className="size-5" />
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto bg-transparent border-primary-foreground/25 text-primary-foreground hover:bg-primary-foreground/10 text-base px-6 py-6 rounded-xl transition-[background-color,border-color]">
                <Link to="/ContactsPage" className="inline-flex items-center gap-2">
                  <PhoneCall className="size-4" />
                  <span>Falar com engenharia</span>
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}